import React, { ReactNode, useEffect, useState } from 'react';
import { Box, Container, RefreshButton } from './styles';

interface ErrorBoundaryProps {
  children: ReactNode;
}

function ErrorBoundary({ children }: ErrorBoundaryProps) {
  const [hasError, setHasError] = useState(false);

  useEffect(() => {
    const errorHandler = (event: ErrorEvent) => {
      console.error('Erro global não capturado:', event.error);
      setHasError(true);
    };

    window.addEventListener('error', errorHandler);

    return () => {
      window.removeEventListener('error', errorHandler);
    };
  }, []);

  if (hasError) {
    return (
      <Container>
        <Box>
          <h1>Ops, algo deu errado.</h1>
          <p>Por favor, recarregue a página ou tente novamente mais tarde.</p>
          <RefreshButton onClick={() => window.location.reload()}>
            Recarregar
          </RefreshButton>
        </Box>
      </Container>
    );
  }

  return <>{children}</>;
}

export default ErrorBoundary;
